import { useEffect, useRef } from 'react';
import '../styles/MysticalWave.css';

function MysticalWave() {
    const waveRef = useRef(null);

    useEffect(() => {
        if (!waveRef.current) return;
        
        // Set initial opacity immediately
        waveRef.current.style.opacity = '0.18';
        
        const handleScroll = () => {
            if (!waveRef.current) return;
            
            const industriesSection = document.querySelector('.redesign-industries');
            if (!industriesSection) return;

            const rect = industriesSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Just fade in/out, no movement
            const isVisible = rect.top < windowHeight && rect.bottom > 0;
            waveRef.current.style.opacity = isVisible ? '0.18' : '0';
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div ref={waveRef} className="mystical-wave">
            <svg viewBox="0 0 1200 800" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" className="wave-stop-start" stopOpacity="0" />
                        <stop offset="15%" className="wave-stop" stopOpacity="0.3" />
                        <stop offset="50%" className="wave-stop" stopOpacity="0.35" />
                        <stop offset="85%" className="wave-stop" stopOpacity="0.3" />
                        <stop offset="100%" className="wave-stop-end" stopOpacity="0" />
                    </linearGradient>
                    <filter id="glow">
                        <feGaussianBlur stdDeviation="30" result="coloredBlur"/>
                        <feFlood className="wave-glow" floodOpacity="0.8" result="glowColor"/>
                        <feComposite in="glowColor" in2="coloredBlur" operator="in" result="softGlow"/>
                        <feMerge>
                            <feMergeNode in="softGlow"/>
                            <feMergeNode in="softGlow"/>
                            <feMergeNode in="softGlow"/>
                            <feMergeNode in="softGlow"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                
                {/* Elegant thin waves - more refined */}
                <path 
                    d="M -100,200 C 20,175 80,225 200,200 S 320,175 400,200 S 520,225 600,200 S 720,175 800,200 S 920,225 1000,200 S 1120,175 1300,200" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="35" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-1"
                />
                
                <path 
                    d="M -100,230 C 20,205 80,255 200,230 S 320,205 400,230 S 520,255 600,230 S 720,205 800,230 S 920,255 1000,230 S 1120,205 1300,230" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="28" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-2"
                />
                
                <path 
                    d="M -100,260 C 20,235 80,285 200,260 S 320,235 400,260 S 520,285 600,260 S 720,235 800,260 S 920,285 1000,260 S 1120,235 1300,260" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="22" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-3"
                />
                
                <path 
                    d="M -100,170 C 20,145 80,195 200,170 S 320,145 400,170 S 520,195 600,170 S 720,145 800,170 S 920,195 1000,170 S 1120,145 1300,170" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="30" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-4"
                />
                
                {/* Lower elegant waves */}
                <path 
                    d="M -100,480 C 20,455 80,505 200,480 S 320,455 400,480 S 520,505 600,480 S 720,455 800,480 S 920,505 1000,480 S 1120,455 1300,480" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="32" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-5"
                />
                
                <path 
                    d="M -100,510 C 20,485 80,535 200,510 S 320,485 400,510 S 520,535 600,510 S 720,485 800,510 S 920,535 1000,510 S 1120,485 1300,510" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="26" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-6"
                />
                
                <path 
                    d="M -100,540 C 20,515 80,565 200,540 S 320,515 400,540 S 520,565 600,540 S 720,515 800,540 S 920,565 1000,540 S 1120,515 1300,540" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="20" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-7"
                />
                
                <path 
                    d="M -100,450 C 20,425 80,475 200,450 S 320,425 400,450 S 520,475 600,450 S 720,425 800,450 S 920,475 1000,450 S 1120,425 1300,450" 
                    fill="none" 
                    stroke="url(#waveGradient)" 
                    strokeWidth="24" 
                    strokeLinecap="round"
                    filter="url(#glow)"
                    className="wave-path wave-8"
                />
            </svg>
        </div>
    );
}

export default MysticalWave;
